import React, {lazy, Suspense} from 'react';
import {Switch, Route} from 'react-router-dom';
import Auth from '../redux/components/Auth';

import {Error404} from './common/Error';
import {CenteredSpinner} from './common/Loading';
import Header from './Header';
import UIDemo from './UIDemo';
import UserSettings from './UserSettings';
import ManageAppDefaults from './AdminForms/ManageAppDefaults';
import Reporting from './Reporting/Reporting';
import {Grid} from '@mui/material';

function RootMainBody(props) {
    const ApproveInvoices = lazy(
        () => import('./ApproveInvoices/ApproveInvoices')
    );
    const Dashboard = lazy(() => import('./Dashboard'));
    const InvoiceEdit = lazy(() => import('./InvoiceEdit'));
    const TabbedResearch = lazy(
        () => import('./InvoiceResearch/TabbedResearch')
    );
    const TabbedManageExceptions = lazy(
        () => import('./ManageExceptions/TabbedManageExceptons')
    ); 
    const ManageExceptions = lazy(() => import('./ManageExceptions/ManageExceptions'));
    const InvoiceEntry = lazy(() => import('./InvoiceEntry/InvoiceEntry'));
    const ManageImages = lazy(() => import('./ManageImages/ManageImages'));
    const UploadImages = lazy(() => import('./ImageUpload/ImageUpload'));
    const CentralSaltTickets = lazy(
        () => import('./CentralSaltTickets/CentralSaltTickets')
    );

    const Receivables = lazy(() => import('./Receivables'));
    const CustImgExtract = lazy(() => import('./CustImageExtract'));

    const AccountingForms = lazy(() => import('./AccountingForms/Accounting'));
    const AdminForms = lazy(() => import('./AdminForms'));
    const CarrierAdmin = lazy(() => import('./CarrierAdmin'));
    const CustomerAdmin = lazy(() => import('./CustomerAdmin'));
    const GLCoding = lazy(() => import('./GLCoding/GLCodingAdmin'));
    const MassRefUpdate = lazy(() => import('./MassRefUpdate'));
    const MatchFiles = lazy(() => import('./MatchFiles/MatchFiles'));
    const FeesAppRuleForm = lazy(() => import('./FeesApp/FeesAppRuleForm'));
    const FeesApp = lazy(() => import('./FeesApp/FeesAppTabs'));

    const ITAdmin = lazy(() => import('./ITAdmin/ITAdmin'));
    const InvoiceMaintenance = lazy(
        () => import('./InvoiceMaintenance/InvoiceMaintenance')
    );

    return (
        <Grid className="mainBody" container>
            <Grid item xs={12} display="flex">
                <Suspense fallback={<CenteredSpinner></CenteredSpinner>}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={(props) => <Dashboard {...props} />}
                        />
                        <Route
                            path="/approveinvoices"
                            render={(props) => <ApproveInvoices {...props} />}
                        />
                        <Route
                            exact
                            path="/invoice/:type/:id"
                            render={(props) => <InvoiceEdit {...props} />}
                        />
                        <Route
                            path="/invoices"
                            render={(props) => <TabbedResearch {...props} />}
                        />
                        <Route
                            path="/uidemo"
                            render={(props) => <UIDemo {...props}></UIDemo>}
                        />
                        <Route
                            path="/usersettings"
                            render={(props) => (
                                <UserSettings {...props}></UserSettings>
                            )}
                        />
                        <Route
                            path="/manageExceptions"
                            render={(props) => (
                                <TabbedManageExceptions {...props}></TabbedManageExceptions>
                            )}
                        />
                        <Route
                            path="/invoiceEntry"
                            render={(props) => <InvoiceEntry {...props} />}
                        />
                        <Route
                            path="/manageImages"
                            render={(props) => <ManageImages {...props} />}
                        />
                        <Route
                            path="/uploadImages"
                            render={(props) => <UploadImages {...props} />}
                        />
                        <Route
                            path="/centralSalt"
                            render={(props) => (
                                <CentralSaltTickets {...props} />
                            )}
                        />
                        <Route
                            path="/receivables"
                            render={(props) => <Receivables {...props} />}
                        />
                        <Route
                            path="/imageExtract"
                            render={(props) => <CustImgExtract {...props} />}
                        />
                        <Route
                            path="/itadmin"
                            render={(props) => <ITAdmin {...props}></ITAdmin>}
                        />
                        <Route
                            path="/accounting"
                            render={(props) => <AccountingForms {...props} />}
                        />
                        <Route
                            path="/adminForms"
                            render={(props) => <AdminForms {...props} />}
                        />
                        <Route
                            path="/carrierAdmin"
                            render={(props) => <CarrierAdmin {...props} />}
                        />
                        <Route
                            path="/customerAdmin"
                            render={(props) => <CustomerAdmin {...props} />}
                        />
                        <Route
                            path="/glCoding"
                            render={(props) => <GLCoding {...props} />}
                        />
                        <Route
                            path="/massRefUpdate"
                            render={(props) => <MassRefUpdate {...props} />}
                        />
                        <Route
                            path="/matchFiles"
                            render={(props) => <MatchFiles {...props} />}
                        />
                        <Route
                            path="/feesApp"
                            render={(props) => <FeesApp {...props} />}
                        />
                        <Route
                            path="/feesAppRules"
                            render={(props) => <FeesAppRuleForm {...props} />}
                        />
                        <Route
                            path="/invoiceMaintenance"
                            render={(props) => (
                                <InvoiceMaintenance {...props} />
                            )}
                        />
                        <Route
                            path="/reporting"
                            render={(props) => <Reporting {...props} />}
                        />
                        <Route
                            path="/appdefaults"
                            render={(props) => <ManageAppDefaults {...props} />}
                        />
                        <Route render={(props) => <Error404 {...props} />} />
                    </Switch>
                </Suspense>
            </Grid>
        </Grid>
    );
}

export const MainBody = () => (
    <Auth header={<Header></Header>}>
        <RootMainBody></RootMainBody>
    </Auth>
);
